import { parseDate } from "simple-utils/dist/date-utils";
import { Note } from "../models/Note";
import { load } from "./basic-loader";

export async function getNote(account: number):Promise<Note>{
    var result = await load(`notes/${account}`, {}) 
    if(!result.note)
        return null;
    result = result.note;
    return {
        content: result.note,
        updated: parseDate(result.updated),
        updatedBy: result.updatedBy
    }   
}

export async function updateNote(account: number, note:string){
    const result = await load(`notes/${account}`, {}, {note}) 
    return {
        content: result.note,
        updated: parseDate(result.updated),
        updatedBy: result.updatedBy
    }      
}